import { TipoBando } from "./tipoBando.model";

export class Bando {
    id: Number;
    denominazione: String;
    tipo: TipoBando;

  }
  